import * as Icons from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { SERVICES } from "../data/site";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-[#050505] px-6 py-24 md:px-12 md:py-32">
    <div className="mx-auto max-w-7xl">
      <SectionHead
        id="services"
        overline="Chapter 02 — What We Build"
        title="Services"
        desc="From structural steel fabrication to complete prefabricated buildings — every service delivered with engineering discipline and professional workmanship."
      />

      <div className="mt-16 grid grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon];
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08} className="bg-[#050505]">
              <div
                data-testid={`service-card-${i + 1}`}
                className="group relative h-full bg-[#0A0A0A] p-8 transition-colors duration-500 hover:bg-[#0D1420]"
              >
                <span className="absolute right-6 top-6 font-display text-xs font-bold tracking-widest text-white/25">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <Icon
                  size={32}
                  strokeWidth={1.5}
                  className="text-[#0055FF] transition-transform duration-500 group-hover:-translate-y-1"
                />
                <h3 className="mt-6 font-display text-xl font-semibold tracking-tight transition-colors group-hover:text-[#3377FF]">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[#A3A3A3]">{s.desc}</p>
                <span className="mt-6 block h-px w-8 bg-[#0055FF] transition-all duration-500 group-hover:w-16" />
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
